import { TechnicalSupportForm } from './TechnicalSupportScreen';

export interface TechnicalSupportField {
  idx: number;
  key: keyof TechnicalSupportForm & string;
  props: {
    label: string;
    placeholder?: string;
    accessibilityLabel: string;
    icon?: string;
    // Generic Options
    required?: boolean;
    multiline?: boolean;
    rowsMax?: number;
    maxLength?: number;
    fieldHeight?: string;
  };
}

export const TECHNICAL_SUPPORT_FIELDS: TechnicalSupportField[] = [
  {
    idx: 0,
    key: 'firstName',
    props: {
      label: 'First Name',
      required: true,
      accessibilityLabel: 'First name text input',
      maxLength: 120
    }
  },
  {
    idx: 1,
    key: 'lastName',
    props: {
      label: 'Last Name',
      required: true,
      accessibilityLabel: 'Last name text input',
      maxLength: 120
    }
  },
  {
    idx: 2,
    key: 'preferredPhone',
    props: {
      label: 'Preferred Phone',
      required: true,
      icon: 'phone',
      accessibilityLabel: 'Preferred phone text input',
      maxLength: 14
    }
  },
  {
    idx: 3,
    key: 'email',
    props: {
      label: 'Email',
      required: false,
      accessibilityLabel: 'Email text input',
      maxLength: 120
    }
  },
  {
    idx: 4,
    key: 'issueDescription',
    props: {
      label: 'Issue Description',
      placeholder: `Describe your issue, please include as much detail as possible such as:

      What you were trying to do?

      What happened?

      What device and/or browser were you using?`,
      required: true,
      accessibilityLabel: 'Issue text input',
      multiline: true,
      maxLength: 8192,
      fieldHeight: '150px'
    }
  }
];
